import React from 'react'

interface RetryProps {
  width?: number,
  height?: number
}

const Retry = ({ height = 24, width = 24 }: RetryProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--retry"
      width={width}
      height={height}
      viewBox="0 0 28 24">
          <path d="M27.82 19.074c-0.17 0.085-0.353 0.126-0.53 0.126-0.436 0-0.854-0.244-1.063-0.664l-0.994-2.010c-1.762 4.469-5.996 7.474-11.002 7.474-5.438 0-10.298-3.548-11.82-8.628-0.19-0.635 0.164-1.304 0.792-1.496 0.624-0.193 1.29 0.166 1.48 0.8 1.222 4.076 5.148 6.924 9.548 6.924 4.128 0 7.481-2.436 8.838-6.126l-2.372 1.199c-0.588 0.298-1.3 0.056-1.592-0.536s-0.055-1.313 0.53-1.609l4.748-2.401c0.589-0.296 1.301-0.055 1.594 0.538l2.374 4.8c0.294 0.593 0.055 1.314-0.53 1.61zM25.259 10.126c-0.626 0.191-1.291-0.167-1.481-0.802-1.223-4.076-5.148-6.924-9.547-6.924-4.132 0-7.486 2.437-8.842 6.127l2.375-1.201c0.588-0.296 1.301-0.055 1.592 0.538 0.294 0.593 0.056 1.314-0.53 1.61l-4.748 2.399c-0.17 0.086-0.352 0.127-0.529 0.127-0.437 0-0.856-0.242-1.063-0.662l-2.375-4.801c-0.293-0.593-0.055-1.314 0.532-1.61 0.589-0.296 1.3-0.055 1.592 0.538l0.994 2.008c1.759-4.468 5.994-7.471 11.003-7.471 5.436 0 10.296 3.548 11.819 8.628 0.191 0.635-0.164 1.304-0.791 1.498z"></path>
    </svg>
  )
}

export default Retry

